import { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import db from "../../firebase";

const TaskList = () => {
  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "tasks"), (snapshot) => {
      const tasksData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setTasks(tasksData);
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="task-list">
      {tasks.map((task) => (
        <div key={task.id} className="task-card">
          <h3>{task.taskName}</h3>
          <p><strong>Start:</strong> {task.startDate}</p>
          <p><strong>End:</strong> {task.endDate}</p>
          <p><strong>Type:</strong> {task.taskType}</p>
          <p><strong>Lead:</strong> {task.lead}</p>
          <p><strong>Notes:</strong> {task.notes}</p>
        </div>
      ))}
    </div>
  );
};

export default TaskList;
